import { render, staticRenderFns } from "./GlobalSearchSports.vue?vue&type=template&id=a45a69b8&"
import script from "./GlobalSearchSports.vue?vue&type=script&lang=ts&"
export * from "./GlobalSearchSports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports